export enum TipoTanque{
    CilindroVertical = 0,
    Vertical = 1,
    Horizontal = 2,
    Enterrado = 3,
    EnterradoDoblePared = 4
}